import Api from "../apiService";

class CargoItemRegistriesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/cargo/item_registries`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/cargo/item_registries/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/cargo/item_registries`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/item_registries/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/item_registries/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/item_registries/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }
}

export default new CargoItemRegistriesApi();
